module.exports = __webpack_public_path__ + "img/float-layer-ai_new.78f8390c.png";